function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.667 14.6665H2.33366",
    stroke: "#505050",
    style: {
      stroke: "#505050",
      stroke: "color(display-p3 0.3137 0.3137 0.3137)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.667 2.3335L3.33366 11.6668",
    stroke: "#505050",
    style: {
      stroke: "#505050",
      stroke: "color(display-p3 0.3137 0.3137 0.3137)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.667 9.18016V2.3335H5.82033",
    stroke: "#505050",
    style: {
      stroke: "#505050",
      stroke: "color(display-p3 0.3137 0.3137 0.3137)",
      strokeOpacity: 1
    },
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.afe97b4a88396daf62a1b82aac1e49cd.svg";
export { ForwardRef as ReactComponent };